import gothamUltraWoff from './files/Gotham-Ultra.woff'
import gothamUltraWoff2 from './files/Gotham-Ultra.woff2'
import gothamUltraItalicWoff from './files/Gotham-UltraItalic.woff'
import gothamUltraItalicWoff2 from './files/Gotham-UltraItalic.woff2'
import gothamBlackWoff from './files/Gotham-Black.woff'
import gothamBlackWoff2 from './files/Gotham-Black.woff2'
import gothamBlackItalicWoff from './files/Gotham-BlackItalic.woff'
import gothamBlackItalicWoff2 from './files/Gotham-BlackItalic.woff2'
import gothamBoldWoff from './files/Gotham-Bold.woff'
import gothamBoldWoff2 from './files/Gotham-Bold.woff2'
import gothamBoldItalicWoff from './files/Gotham-BoldItalic.woff'
import gothamBoldItalicWoff2 from './files/Gotham-BoldItalic.woff2'
import gothamMediumWoff from './files/Gotham-Medium.woff'
import gothamMediumWoff2 from './files/Gotham-Medium.woff2'
import gothamMediumItalicWoff from './files/Gotham-MediumItalic.woff'
import gothamMediumItalicWoff2 from './files/Gotham-MediumItalic.woff2'
import gothamBookWoff from './files/Gotham-Book.woff'
import gothamBookWoff2 from './files/Gotham-Book.woff2'
import gothamBookItalicWoff from './files/Gotham-BookItalic.woff'
import gothamBookItalicWoff2 from './files/Gotham-BookItalic.woff2'
import gothamLightWoff from './files/Gotham-Light.woff'
import gothamLightWoff2 from './files/Gotham-Light.woff2'
import gothamLightItalicWoff from './files/Gotham-LightItalic.woff'
import gothamLightItalicWoff2 from './files/Gotham-LightItalic.woff2'
import gothamExtraLightWoff from './files/Gotham-ExtraLight.woff'
import gothamExtraLightWoff2 from './files/Gotham-ExtraLight.woff2'
import gothamExtraLightItalicWoff from './files/Gotham-ExtraLightItalic.woff'
import gothamExtraLightItalicWoff2 from './files/Gotham-ExtraLightItalic.woff2'
import gothamThinWoff from './files/Gotham-Thin.woff'
import gothamThinWoff2 from './files/Gotham-Thin.woff2'
import gothamThinItalicWoff from './files/Gotham-ThinItalic.woff'
import gothamThinItalicWoff2 from './files/Gotham-ThinItalic.woff2'

const gotham = `
  @font-face {
    font-family: 'Gotham';
    src: local('Gotham Medium'), local('Gotham-Medium'),
      url(${gothamMediumWoff2}) format('woff2'),
      url(${gothamMediumWoff}) format('woff');
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Gotham';
    src: local('Gotham Thin'), local('Gotham-Thin'),
      url(${gothamThinWoff2}) format('woff2'),
      url(${gothamThinWoff}) format('woff');
    font-weight: 100;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Gotham';
    src: local('Gotham Light Italic'), local('Gotham-LightItalic'),
      url(${gothamLightItalicWoff2}) format('woff2'),
      url(${gothamLightItalicWoff}) format('woff');
    font-weight: 300;
    font-style: italic;
  }

  @font-face {
    font-family: 'Gotham';
    src: local('Gotham Medium Italic'), local('Gotham-MediumItalic'),
      url(${gothamMediumItalicWoff2}) format('woff2'),
      url(${gothamMediumItalicWoff}) format('woff');
    font-weight: 500;
    font-style: italic;
  }

  @font-face {
    font-family: 'Gotham';
    src: local('Gotham Black'), local('Gotham-Black'),
      url(${gothamBlackWoff2}) format('woff2'),
      url(${gothamBlackWoff}) format('woff');
    font-weight: 900;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Gotham';
    src: local('Gotham Black Italic'), local('Gotham-BlackItalic'),
      url(${gothamBlackItalicWoff2}) format('woff2'),
      url(${gothamBlackItalicWoff}) format('woff');
    font-weight: 900;
    font-style: italic;
  }

  @font-face {
    font-family: 'Gotham';
    src: local('Gotham Book'), local('Gotham-Book'),
      url(${gothamBookWoff2}) format('woff2'),
      url(${gothamBookWoff}) format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Gotham';
    src: local('Gotham Bold Italic'), local('Gotham-BoldItalic'),
      url(${gothamBoldItalicWoff2}) format('woff2'),
      url(${gothamBoldItalicWoff}) format('woff');
    font-weight: bold;
    font-style: italic;
  }

  @font-face {
    font-family: 'Gotham Ultra';
    src: local('Gotham Ultra Italic'), local('Gotham-UltraItalic'),
      url(${gothamUltraItalicWoff2}) format('woff2'),
      url(${gothamUltraItalicWoff}) format('woff');
    font-weight: normal;
    font-style: italic;
  }

  @font-face {
    font-family: 'Gotham';
    src: local('Gotham Book Italic'), local('Gotham-BookItalic'),
      url(${gothamBookItalicWoff2}) format('woff2'),
      url(${gothamBookItalicWoff}) format('woff');
    font-weight: 400;
    font-style: italic;
  }

  @font-face {
    font-family: 'Gotham';
    src: local('Gotham Thin Italic'), local('Gotham-ThinItalic'),
      url(${gothamThinItalicWoff2}) format('woff2'),
      url(${gothamThinItalicWoff}) format('woff');
    font-weight: 100;
    font-style: italic;
  }

  @font-face {
    font-family: 'Gotham Extra';
    src: local('Gotham Extra Light Italic'), local('Gotham-ExtraLightItalic'),
      url(${gothamExtraLightItalicWoff2}) format('woff2'),
      url(${gothamExtraLightItalicWoff}) format('woff');
    font-weight: 200;
    font-style: italic;
  }

  @font-face {
    font-family: 'Gotham';
    src: local('Gotham Bold'), local('Gotham-Bold'),
      url(${gothamBoldWoff2}) format('woff2'),
      url(${gothamBoldWoff}) format('woff');
    font-weight: bold;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Gotham Ultra';
    src: local('Gotham Ultra'), local('Gotham-Ultra'),
      url(${gothamUltraWoff2}) format('woff2'),
      url(${gothamUltraWoff}) format('woff');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Gotham Extra';
    src: local('Gotham Extra Light'), local('Gotham-ExtraLight'),
      url(${gothamExtraLightWoff2}) format('woff2'),
      url(${gothamExtraLightWoff}) format('woff');
    font-weight: 200;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Gotham';
    src: local('Gotham Light'), local('Gotham-Light'),
      url(${gothamLightWoff2}) format('woff2'),
      url(${gothamLightWoff}) format('woff');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }

`

export default gotham
